import { AirChfarExerciseDiscountUpdate } from "@b2bportal/air-chfar-api";
import { Payment, PaymentOpaqueValue } from "@b2bportal/purchase-api";
import { PartialParentContext, ParentState } from "@checkout/types";
import { RequiredField } from "@hopper-b2b/utilities";

export interface AirChfarExerciseDiscount extends PaymentOpaqueValue {
  type: typeof Payment.AirChfarExerciseDiscount;
  value: AirChfarExerciseDiscountUpdate;
}

export enum ChFARExerciseState {
  route = "route",
  addDiscount = "addDiscount",
  error = "error",
}

export type ParentContextWithChfarExerciseDiscount = RequiredField<
  PartialParentContext,
  ParentState.changeForAnyReasonDiscount
>;
